import { useQuery } from '@tanstack/react-query';
import { getManagementOrgsPromise } from 'src/utils';
import { QUERY_KEY_MAP } from 'src/constants';

export const useGetManagementOrgs = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetManagementOrgs],
    queryFn: getManagementOrgsPromise,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export const useGetOrgDetailsByOrgId = (orgId: string) => {
  const { data, isLoading, error } = useGetManagementOrgs();
  const orgDetails = data?.raw?.find((org) => org.org_id?.toLowerCase() === orgId?.toLowerCase());

  return {
    orgDetails,
    isLoading,
    error,
  };
};
